import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ConfigService {
  private config: any = null;

  constructor() { }

  async load(): Promise<void> {
    console.log('[ConfigService] config.service.ts entered:');
    try {
      const response = await fetch('/assets/config.json');
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const cfg = await response.json();
      // Fix scope format if pipeline substituted it as a string
      if (typeof cfg.apiConfig?.scopes === 'string') {
        console.warn('[ConfigService] Scopes was a string, converting to array');
        cfg.apiConfig.scopes = [cfg.apiConfig.scopes];
      }
      this.config = cfg;
      console.log('[ConfigService] config.json loaded:', this.config);
    } catch (err) {
      console.error('[ConfigService] Failed to load config.json:', err);
      throw err;
    }
  }

  get(key: string): any {
    return this.config ? this.config[key] : null;
  }

  get msalConfig(): any {
    return this.get('msalConfig');
  }

  get apiConfig(): any {
    return this.get('apiConfig');
  }
}
